export enum IdentityProviderCreateMethodTypes {
    USE_BLANK = "0",
    USE_IMPORT = "1",
    USE_COPY = "2"
}